export default __webpack_public_path__ + "static/media/white-logo.821c549a.svg";